import { Confirmation, ConfirmationService } from 'primeng/api';

export function deleteConfirmationDialog(
  confirmationService: ConfirmationService,
  options: Partial<Confirmation> = {},
) {
  return confirmationService.confirm({
    message: 'Questa azione non può essere annullata.',
    header: 'Conferma eliminazione',
    icon: 'pi pi-exclamation-triangle',
    closable: false,
    closeOnEscape: true,
    rejectButtonProps: { label: 'Annulla', severity: 'secondary' },
    acceptButtonProps: { label: 'Elimina', severity: 'danger' },
    rejectButtonStyleClass: 'min-w-30 p-button-text',
    acceptButtonStyleClass: 'min-w-30',
    ...options,
  });
}

export function exitConfirmationDialog(
  confirmationService: ConfirmationService,
  options: Partial<Confirmation> = {},
) {
  return confirmationService.confirm({
    message: 'Tutte le modifiche non salvate verranno perse.',
    header: 'Conferma uscita',
    icon: 'pi pi-exclamation-triangle',
    closable: false,
    closeOnEscape: true,
    rejectButtonProps: {
      label: 'Annulla',
      severity: 'secondary',
    },
    acceptButtonProps: { label: 'Esci' },
    rejectButtonStyleClass: 'min-w-30 p-button-text',
    acceptButtonStyleClass: 'min-w-30',
    ...options,
  });
}

export function confirmActionDialog(
  confirmationService: ConfirmationService,
  options: Partial<Confirmation> = {},
) {
  return confirmationService.confirm({
    message: 'Sei sicuro di voler procedere?',
    header: 'Conferma',
    icon: 'pi pi-exclamation-triangle',
    closable: false,
    closeOnEscape: true,
    rejectButtonProps: { label: 'Annulla', severity: 'secondary' },
    acceptButtonProps: { label: 'Conferma' },
    rejectButtonStyleClass: 'min-w-30 p-button-text',
    acceptButtonStyleClass: 'min-w-30',
    ...options,
  });
}

export function alertDialog(
  confirmationService: ConfirmationService,
  options: Partial<Confirmation> = {},
) {
  return confirmationService.confirm({
    header: 'Attenzione',
    icon: 'pi pi-exclamation-triangle',
    rejectVisible: false,
    acceptButtonProps: { label: 'Ok' },
    rejectButtonStyleClass: 'min-w-30 p-button-text',
    acceptButtonStyleClass: 'min-w-30',
    ...options,
  });
}

export function publishConfirmationDialog(
  confirmationService: ConfirmationService,
  options: Partial<Confirmation> = {},
) {
  return confirmationService.confirm({
    message: 'Questa azione non può essere annullata.',
    header: 'Conferma pubblicazione',
    icon: 'pi pi-exclamation-triangle',
    closable: false,
    closeOnEscape: true,
    rejectButtonProps: { label: 'Annulla', severity: 'secondary' },
    acceptButtonProps: { label: 'Pubblica', severity: 'contrast' },
    rejectButtonStyleClass: 'min-w-30 p-button-text',
    acceptButtonStyleClass: 'min-w-30',
    ...options,
  });
}
